var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldExplore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91661 6.99989L7.08327 8.16655L9.41661 5.83321M12.3333 6.99989C12.3333 9.6022 9.14827 11.4879 8.04076 12.065C7.921 12.1274 7.86109 12.1586 7.77802 12.1748C7.71327 12.1874 7.61994 12.1874 7.55519 12.1748C7.47212 12.1586 7.41221 12.1274 7.29246 12.065C6.18492 11.4879 2.99994 9.6022 2.99994 6.99989V4.79348C2.99994 4.3271 2.99994 4.09391 3.07622 3.89346C3.1436 3.71638 3.25309 3.55838 3.39524 3.43311C3.55615 3.2913 3.77449 3.20943 4.21117 3.04567L7.33889 1.87278C7.46016 1.8273 7.52077 1.80456 7.58319 1.79554C7.63849 1.78755 7.69472 1.78755 7.75002 1.79554C7.81244 1.80456 7.87305 1.8273 7.99432 1.87278L11.122 3.04567C11.5587 3.20943 11.7771 3.2913 11.9379 3.43311C12.0801 3.55838 12.1896 3.71638 12.257 3.89346C12.3333 4.09391 12.3333 4.3271 12.3333 4.79348V6.99989Z",
    stroke: "#10A37F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldExplore);
export default __webpack_public_path__ + "static/media/shieldExplore.e1dea80cc3e60787001f53bb8e956242.svg";
export { ForwardRef as ReactComponent };